export function smoothScroll() {
  const links = document.querySelectorAll('a[href*="#"]');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const scrollBehavior = prefersReducedMotion ? 'auto' : 'smooth';

  links.forEach(link => {
    link.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (!href) return;

      // "#" のみ
      if (href === '#') {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: scrollBehavior
        });
        return;
      }

      try {
        const url = new URL(href, location.href);

        // ハッシュが存在しない
        if (!url.hash) return;

        // 同一ページのみ対象
        if (url.pathname !== location.pathname) return;

        const targetId = url.hash.substring(1);
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          e.preventDefault();
          targetElement.scrollIntoView({
            behavior: scrollBehavior,
            block: 'start'
          });
        }
      } catch (error) {
        // 無効なURLなどは無視
        return;
      }
    });
  });
}